<template lang="html">
	<div class="notifications-panel-container" :class="{active: open}" @click="setActive">
		<section class="notification-panel" @click.stop>
			<div class="head row">
				<span class="icon-volet-notif"></span>
				<div class="label">
					Notifications
				</div>
				<span class="close icon-form-close" @click="setActive"></span>
			</div>
			<div class="custom-notif ctn-free-trial notification" v-if="isClient">
				<div class="label">
					Vous disposez d'un essai gratuit
				</div>
				<div class="date">
					Jusqu'au 02/01/2019
				</div>
				<div class="btn btn-red" @click="goToAbo">
					Renouveler maintenant
				</div>
			</div>
			<div class="custom-notif ctn-next-appointment notification">
				<div class="label">
					Votre prochain rendez-vous
				</div>
				<div class="date">
					Lundi 04 Mars 2018 de 14h à 16h
				</div>
				<div class="content">
					<div class="advisor row">
						<div class="ctn-profile-picture">
							<img :src="picture" alt="" v-img-detect>
						</div>
						<div class="name">
							Avec <span class="bold">Mr Pitois</span>
						</div>
					</div>
					<div class="subject">
						<div class="text">Points à aborder :</div>
						<div class="value">Assurance vie / Immobilier</div>
					</div>

				</div>
			</div>
			<div class="ctn-notifications">
				<div class="notification" v-for="(notification, key) in notifications" v-bind:key="key">
					<div class="head-notif row" v-if="notification.type === 'article'">
						<span class="icon-notif-article"></span>
						<div class="label">Nouvel Article</div>
						<div class="hour">{{ notification.date | moment('HH[h]mm') }}</div>
					</div>
					<div class="body-notif">
						{{ notification.text }}
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
	name: 'NotificationPanel',
	mounted () {
		this.$store.dispatch('fetchNotifications', this.user)
	},
	methods: {
		setActive () {
			this.$store.commit('CLOSE_NOTIF')
		},
		goToAbo () {
			this.$store.commit('CLOSE_NOTIF')
			this.$router.push({ name: 'MySubscriptions' })
		}
	},
	computed: {
		...mapGetters({
			notifications: 'notifications',
			user: 'user',
			open: 'open'
		}),
		isClient () {
			return this.user.role === 'CLIENT'
		},
		picture () {
			return (this.user.picture) ? process.env.ASSETS_ROOT + this.user.picture : process.env.API_ROOT + '/assets/user.png'
		}
	}
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// notification-panel.vue?9cf44c76